import { IRI } from '@/api';
import { startsWith } from 'lodash';

export default {
  payload: (state) => {
    const payload = Object.assign({ courses: [] }, state.item);
    payload.courses = payload.courses.map(course => {
      if (course.course && !startsWith(course.course, IRI.course)) {
        course.course = `${IRI.course}${course.id}`;
      }
      course.expiresAt = payload.expiresAt;
      return course;
    });

    return payload;
  },
};
